import { postRequest, ApiResponse } from "@/data/apiClient";

export interface userDeleteResponse {
  id: number;
}

export async function userDelete(
  userId: number
): Promise<ApiResponse<userDeleteResponse>> {
  return postRequest("user/delete", { userId });
}
